export default "__VITE_ASSET__a28572c7__"